/*!
 *  (c)(r) 2008-2025 IT-Service Robert Frunzke
 */

import { jQuery } from '../other/jquery-hooked.js';
import { tinycolor } from '../vendor/tinycolor.js';

/**
 * Manja ColorPicker Widget ( .mjColorPicker )
 *
 * methods:
 *  - TODO
 *
 * usage:
 *  $('input').mjColorPicker( { ... } )
 *
 */

(function($) {

	// using the new $.widget utility..
	$.widget( 'mj.mjColorPicker', {

		options: {
			withAlpha: false,

			// callbacks
			change: null,
		},

		_events: {
			change: function( event ) {
				// console.log('change');
				if( this._try_extract_color_value()==='error' ) {
					this._set_element_error();
				} else {
					this._set_element_value(this._hex_val,this._hex_alpha_val,false);
					this._trigger( 'change', event );
				}
			}
		},

		_create: function() {
			this._val_state = '';
			this._hex_val = '#000000';
			this._hex_alpha_val = '';
			if( this._try_extract_color_value()==='error' ) {
				this._set_element_error();
			} else {
				this._set_element_value(this._hex_val,this._hex_alpha_val,true);
			}

			this._on(this._events);

			const thisWidget = this;
			const wdgElem = this.element;
			this.element.ColorPicker( {
				color: this._hex_val,
				onShow: function( colpkr ) {
					$(colpkr).css('zIndex',3005).fadeIn(200);
					wdgElem.ColorPickerSetColor(thisWidget._hex_val);
					return false;
				},
				onHide: function( colpkr ) {
					// console.log('onHide');
					if( !wdgElem.is(':focus') ) {
						// restore ..
						thisWidget._set_element_value(thisWidget._hex_val,thisWidget._hex_alpha_val,true);
						wdgElem.trigger('change');
					}
					$(colpkr).fadeOut(200);
					return false;
				},
				onChange: function( hsb, hex, rgb ) {
					// console.log('onChange');
					thisWidget._set_element_value('#'+hex.toUpperCase(),thisWidget._hex_alpha_val,false);
				},
				onSubmit: function( hsb, hex, rgb, el ) {
					thisWidget._hex_val = '#'+hex.toUpperCase();
					thisWidget._set_element_value(thisWidget._hex_val,thisWidget._hex_alpha_val,true);
					wdgElem.ColorPickerHide();
					wdgElem.trigger('change');
				},
			} );
		},


		value: function( newVal ) {
			if( !arguments.length ) {
				return this._value();
			}
			this.element.val(newVal.toUpperCase());
			this.element.trigger('change');
		},

		_value: function() {
			const val = this.element.val();
			if( !this.options.withAlpha ) {
				return val.slice(0,7);
			}
			return val;
		},

		isEmpty: function() {
			const val = this.element.val();
			return val==='';
		},

		isValid: function() {
			const val = this.element.val();
			if( val==='' ) return true;
			const tc = tinycolor(val);
			return tc.isValid();
		},








		_try_extract_color_value: function() {
			const wdg_val = this._value();
			if( wdg_val==='' ) {
				this._hex_val = '';
				this._hex_alpha_val = '';
				this._val_state = 'empty';
			} else {
				const tc = tinycolor(wdg_val);
				if( tc.isValid() ) {
					this._hex_val = tc.toHexString().toUpperCase();
					this._hex_alpha_val = tc.toHex8String(false).substr(7,2).toUpperCase();
					this._val_state = 'valid';
				} else {
					this._val_state = 'error';
				}
			}
			// console.log({w:'_try_extract_color_value',state:this._val_state,_hex_val:this._hex_val,_hex_alpha_val:this._hex_alpha_val});
			return this._val_state;
		},

		_set_element_value: function( hex_val, hex_alpha_val, keep ) {
			if( hex_val==='' ) {
				// console.log({w:'_set_element_value',hex_val,hex_alpha_val,keep,curVal:this._value()});
				this.element
					.val('')
					.removeClass('error')
					.css({
						background: 'inherit',
						color: 'inherit',
					});
				return;
			}


			if( hex_alpha_val==null ) {
				if( hex_val.length>=9 ) {
					hex_alpha_val = hex_val.substr(7,2);
					hex_val = hex_val.substr(0,7);
				} else if( hex_val==='' ) {
					hex_alpha_val = '';
				} else {
					hex_alpha_val = 'ff';
				}
			}
			// console.log({w:'_set_element_value',hex_val,hex_alpha_val,keep,curVal:this._value()});

			const bg = tinycolor( hex_val==='' ? '' : (hex_val+hex_alpha_val) );
			const fgcandidates = bg.splitcomplement();
			const fgc = tinycolor.mostReadable(bg,fgcandidates,{includeFallbackColors:true});

			let bg_val = bg.toHex8String(false).toUpperCase();
			if( !this.options.withAlpha ) {
				bg_val = bg_val.slice(0,7);
			}
			this.element
				.val(bg_val)
				.removeClass('error')
				.css({
					//'backgroundColor': bg.setAlpha(1).toHex8String(false),
					background: 'linear-gradient(to right, '+bg.toHexString(false)+' 66%,'+bg.toHex8String(false)+' 100%)',
					color: fgc.toHexString()
				});
		},

		_set_element_error: function() {
			// console.log({w:'_set_element_error',curVal:this._value()});
			this.element
				.addClass('error')
				.css({
					background: 'inherit',
					color: 'inherit',
				});
		},


		// _setOption: function( k, v ) {
		// 	this._super( k, v );
		// 	// TODO
		// },

		widget: function() {
			return this.mjMjColorPicker;
		},

		_destroy: function() {
			this.element.ColorPickerHide();
		},

	} );

})(jQuery);

